module.exports = __webpack_public_path__ + "img/sn.76db6ed5.svg";